export var KeepaliveSvc = (function () {
    function KeepaliveSvc() {
    }
    return KeepaliveSvc;
}());
//# sourceMappingURL=keepalivesvc.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/@ng-idle/core/src/keepalivesvc.js
// module id = ../../../../@ng-idle/core/src/keepalivesvc.js
// module chunks = 3